import type { CustomFlowbiteTheme } from "flowbite-react";

const customTheme: CustomFlowbiteTheme = {
    button:{
      "color": {
        "dark": "border border-transparent bg-gray-800 text-white focus:ring-4 focus:ring-gray-300 enabled:hover:bg-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:focus:ring-gray-800 dark:enabled:hover:bg-gray-700",
        "failure": "border border-transparent bg-red-700 text-white focus:ring-4 focus:ring-red-300 enabled:hover:bg-red-800 dark:bg-red-600 dark:focus:ring-red-900 dark:enabled:hover:bg-red-700",
        // gray
        "gray": "focus:ring-softprimary border border-gray-200 bg-white text-gray-900 focus:text-darkprimary focus:ring-4 enabled:hover:bg-gray-100 enabled:hover:text-darkprimary dark:border-dm-border dark:bg-transparent dark:text-dm-text-muted dark:enabled:hover:bg-dm-hover dark:enabled:hover:text-dm-text",
        // default
        "info": "border border-transparent bg-primary text-main focus:ring-4 focus:ring-softprimary enabled:hover:bg-darkprimary dark:bg-primary dark:focus:ring-darkprimary dark:enabled:hover:bg-darkprimary hover:text-white",
        "light": "border border-gray-300 bg-white text-gray-900 focus:ring-4 focus:ring-cyan-300 enabled:hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-600 dark:text-white dark:focus:ring-gray-700 dark:enabled:hover:border-gray-700 dark:enabled:hover:bg-gray-700",
        "purple": "border border-transparent bg-purple-700 text-white focus:ring-4 focus:ring-purple-300 enabled:hover:bg-purple-800 dark:bg-purple-600 dark:focus:ring-purple-900 dark:enabled:hover:bg-purple-700",
        "success": "border border-transparent bg-green-700 text-white focus:ring-4 focus:ring-green-300 enabled:hover:bg-green-800 dark:bg-green-600 dark:focus:ring-green-800 dark:enabled:hover:bg-green-700",
        "warning": "border border-transparent bg-yellow-400 text-white focus:ring-4 focus:ring-yellow-300 enabled:hover:bg-yellow-500 dark:focus:ring-yellow-900",
        "blue": "border border-transparent bg-blue-700 text-white focus:ring-4 focus:ring-blue-300 enabled:hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
        "cyan": "border border-cyan-300 bg-white text-cyan-900 focus:ring-4 focus:ring-cyan-300 enabled:hover:bg-cyan-100 dark:border-cyan-600 dark:bg-cyan-600 dark:text-white dark:focus:ring-cyan-700 dark:enabled:hover:border-cyan-700 dark:enabled:hover:bg-cyan-700",
        "green": "border border-green-300 bg-white text-green-900 focus:ring-4 focus:ring-green-300 enabled:hover:bg-green-100 dark:border-green-600 dark:bg-green-600 dark:text-white dark:focus:ring-green-700 dark:enabled:hover:border-green-700 dark:enabled:hover:bg-green-700",
        "indigo": "border border-indigo-300 bg-white text-indigo-900 focus:ring-4 focus:ring-indigo-300 enabled:hover:bg-indigo-100 dark:border-indigo-600 dark:bg-indigo-600 dark:text-white dark:focus:ring-indigo-700 dark:enabled:hover:border-indigo-700 dark:enabled:hover:bg-indigo-700",
        "lime": "border border-lime-300 bg-white text-lime-900 focus:ring-4 focus:ring-lime-300 enabled:hover:bg-lime-100 dark:border-lime-600 dark:bg-lime-600 dark:text-white dark:focus:ring-lime-700 dark:enabled:hover:border-lime-700 dark:enabled:hover:bg-lime-700",
        "pink": "border border-pink-300 bg-white text-pink-900 focus:ring-4 focus:ring-pink-300 enabled:hover:bg-pink-100 dark:border-pink-600 dark:bg-pink-600 dark:text-white dark:focus:ring-pink-700 dark:enabled:hover:border-pink-700 dark:enabled:hover:bg-pink-700",
        "red": "border border-red-300 bg-white text-red-900 focus:ring-4 focus:ring-red-300 enabled:hover:bg-red-100 dark:border-red-600 dark:bg-red-600 dark:text-white dark:focus:ring-red-700 dark:enabled:hover:border-red-700 dark:enabled:hover:bg-red-700",
        "teal": "border border-teal-300 bg-white text-teal-900 focus:ring-4 focus:ring-teal-300 enabled:hover:bg-teal-100 dark:border-teal-600 dark:bg-teal-600 dark:text-white dark:focus:ring-teal-700 dark:enabled:hover:border-teal-700 dark:enabled:hover:bg-teal-700",
        "yellow": "border border-yellow-300 bg-white text-yellow-900 focus:ring-4 focus:ring-yellow-300 enabled:hover:bg-yellow-100 dark:border-yellow-600 dark:bg-yellow-600 dark:text-white dark:focus:ring-yellow-700 dark:enabled:hover:border-yellow-700 dark:enabled:hover:bg-yellow-700"
      },
    },
    tabs: {
        "base": "flex flex-col gap-2",
        "tablist": {
            "base": "flex text-center",
            "styles": {
                "default": "flex-wrap border-b border-gray-200 dark:border-dm-border",
                "underline": "-mb-px flex-wrap border-b border-gray-200 dark:border-dm-border",
                "pills": "flex-wrap space-x-2 text-sm font-medium text-gray-500 dark:text-dm-text-muted",
                "fullWidth": "grid w-full grid-flow-col divide-x divide-gray-200 dark:divide-dm-border rounded-none text-sm font-medium shadow"
            },
            "tabitem": {
                "base": "flex items-center justify-center rounded-t-lg py-2 px-4 text-sm font-medium first:ml-0 focus:outline-none focus:ring-4 focus:ring-softprimary disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500",
                styles: {
                    "default": {
                        "base": "rounded-t-lg",
                        "active": {
                            "on": "bg-softprimary font-semibold text-main dark:bg-dm-surface dark:text-dm-text",
                            "off": "font-semibold text-gray-500 hover:text-gray-700 hover:bg-gray-50 dark:text-dm-text-muted dark:hover:text-dm-text dark:hover:bg-dm-hover"
                        }
                    },
                },
                icon: "mr-2 h-5 w-5 text-gray-500 dark:text-dm-text-muted"
            }
        },
    },
    table: {
      root: {
        base: "w-full text-left text-sm text-gray-500 dark:text-dm-text-muted",
        shadow: "absolute left-0 top-0 -z-10 h-full w-full rounded-lg bg-white drop-shadow-md dark:bg-black",
        wrapper: "relative"
      },
      body: {
        base: "group/body",
        cell: {
          base: "px-6 py-4 group-first/body:group-first/row:first:rounded-tl-lg group-first/body:group-first/row:last:rounded-tr-lg group-last/body:group-last/row:first:rounded-bl-lg group-last/body:group-last/row:last:rounded-br-lg"
        }
      },
      head: {
        base: "group/head text-xs uppercase",
        cell: {
          base: "bg-gray-50 px-6 py-3 group-first/head:first:rounded-tl-lg group-first/head:last:rounded-tr-lg dark:bg-dm-surface dark:text-dm-text-secondary"
        }
      },
      row: {
        base: "group/row",
        hovered: "hover:bg-gray-50 dark:hover:bg-dm-hover",
        striped: "odd:bg-white even:bg-gray-50 odd:dark:bg-dm-bg even:dark:bg-dm-surface"
      }
    },
    toggleSwitch: {
      "root": {
        "base": "group flex rounded-lg focus:outline-none",
        "active": {
          "on": "cursor-pointer",
          "off": "cursor-not-allowed opacity-50"
        },
        "label": "ms-3 mt-0.5 text-start text-sm font-medium text-gray-900 dark:text-dm-text"
      },
      "toggle": {
        "base": "relative rounded-full border after:absolute after:rounded-full after:bg-white after:transition-all group-focus:ring-4 group-focus:ring-softprimary",
        "checked": {
          "on": "after:translate-x-full after:border-white rtl:after:-translate-x-full",
          "off": "border-gray-200 bg-gray-200 dark:border-dm-border dark:bg-dm-hover",
          "color": {
            "blue": "border-cyan-700 bg-cyan-700",
            "dark": "bg-dark-700 border-dark-900",
            "failure": "border-red-900 bg-red-700",
            "gray": "border-gray-600 bg-gray-500",
            "green": "border-green-700 bg-green-600",
            "light": "bg-light-700 border-light-900",
            "red": "border-red-900 bg-red-700",
            "purple": "border-purple-900 bg-purple-700",
            "success": "border-green-500 bg-green-500",
            "yellow": "border-yellow-400 bg-yellow-400",
            "warning": "border-yellow-600 bg-yellow-600",
            "cyan": "border-cyan-500 bg-cyan-500",
            "primary": "border-primary bg-primary",
            "lime": "border-lime-400 bg-lime-400",
            "indigo": "border-indigo-400 bg-indigo-400",
            "teal": "bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:bg-gradient-to-br focus:ring-4",
            "info": "border-cyan-600 bg-cyan-600",
            "pink": "border-pink-600 bg-pink-600"
          }
        },
        "sizes": {
          "sm": "h-5 w-9 min-w-9 after:left-px after:top-px after:h-4 after:w-4 rtl:after:right-px",
          "md": "h-6 w-11 min-w-11 after:left-px after:top-px after:h-5 after:w-5 rtl:after:right-px",
          "lg": "h-7 w-14 min-w-14 after:left-1 after:top-0.5 after:h-6 after:w-6 rtl:after:right-1"
        }
      }
    },
    checkbox: {
      "root": {
        "base": "h-4 w-4 rounded border border-gray-300 bg-gray-100 focus:ring-2 dark:border-dm-border dark:bg-dm-hover cursor-pointer",
        "color": {
          "default": "text-primary focus:ring-primary dark:ring-primary dark:focus:ring-primary",
        }
      }
    },
    textInput: {
      "base": "flex",
      "addon": "inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-white px-3 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-600 dark:text-gray-400",
      "field": {
        "base": "relative w-full",
        "icon": {
          "base": "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3",
          "svg": "h-5 w-5 text-gray-500 dark:text-gray-400"
        },
        "rightIcon": {
          "base": "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3",
          "svg": "h-5 w-5 text-gray-500 dark:text-gray-400"
        },
        "input": {
          "base": "block w-full border disabled:cursor-not-allowed disabled:opacity-50",
          "sizes": {
            "sm": "p-2 sm:text-xs",
            "md": "p-2.5 text-sm",
            "lg": "p-4 sm:text-base"
          },
          "colors": {
            "gray": "border-gray-300 bg-white-50 text-gray-900 focus:border-primary focus:ring-primary focus:ring-0 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
            "info": "border-cyan-500 bg-cyan-50 text-cyan-900 placeholder-cyan-700 focus:border-cyan-500 focus:ring-cyan-500 dark:border-cyan-400 dark:bg-cyan-100 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
            "failure": "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500 dark:border-red-400 dark:bg-red-100 dark:focus:border-red-500 dark:focus:ring-red-500",
            "warning": "border-yellow-500 bg-yellow-50 text-yellow-900 placeholder-yellow-700 focus:border-yellow-500 focus:ring-yellow-500 dark:border-yellow-400 dark:bg-yellow-100 dark:focus:border-yellow-500 dark:focus:ring-yellow-500",
            "success": "border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500 dark:border-green-400 dark:bg-green-100 dark:focus:border-green-500 dark:focus:ring-green-500"
          },
          "withRightIcon": {
            "on": "pr-10",
            "off": ""
          },
          "withIcon": {
            "on": "pl-10",
            "off": ""
          },
          "withAddon": {
            "on": "rounded-r-lg",
            "off": "rounded-lg"
          },
          "withShadow": {
            "on": "shadow-sm dark:shadow-sm-light",
            "off": ""
          }
        }
      }
    },
    modal: {
      "root": {
        "base": "fixed inset-x-0 top-0 z-50 h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
        "show": {
          "on": "flex bg-stone-950 bg-opacity-60 dark:bg-opacity-70",
          "off": "hidden"
        },
        "sizes": {
          "sm": "max-w-sm",
          "md": "max-w-md",
          "lg": "max-w-lg",
          "xl": "max-w-xl",
          "2xl": "max-w-2xl",
          "3xl": "max-w-3xl",
          "4xl": "max-w-4xl",
          "5xl": "max-w-5xl",
          "6xl": "max-w-6xl",
          "7xl": "max-w-7xl",
          "semiFull": "max-w-[80vw]",
          "full": "max-w-[90vw]",
        },
      },
      "header": {
        "base": "flex items-start justify-between rounded-t border-b p-5 dark:border-dm-hover",
        "popup": "border-b-0 p-2 pt-4 border-b px-6",
        "title": "text-lg font-bold text-gray-900 dark:text-dm-text",
        "close": {
          "base": "ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-dm-hover dark:hover:text-dm-text",
          "icon": "h-5 w-5"
        }
      },
    "content": {
      "base": "relative h-full w-full p-4 md:h-auto",
      "inner": "relative flex max-h-[90vh] flex-col rounded-lg bg-white shadow dark:bg-dm-bg text-gray-900 dark:text-dm-text"
    },
    },
    badge: {
      root: {
        color: {
          info:    "bg-cyan-100 text-cyan-800 group-hover:bg-cyan-200 dark:bg-cyan-900/30 dark:text-cyan-300 dark:group-hover:bg-cyan-900/50",
          gray:    "bg-gray-100 text-gray-800 group-hover:bg-gray-200 dark:bg-gray-700/50 dark:text-gray-300 dark:group-hover:bg-gray-700",
          failure: "bg-red-100 text-red-800 group-hover:bg-red-200 dark:bg-red-900/30 dark:text-red-300 dark:group-hover:bg-red-900/50",
          success: "bg-green-100 text-green-800 group-hover:bg-green-200 dark:bg-green-900/30 dark:text-green-300 dark:group-hover:bg-green-900/50",
          warning: "bg-yellow-100 text-yellow-800 group-hover:bg-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:group-hover:bg-yellow-900/50",
          indigo:  "bg-indigo-100 text-indigo-800 group-hover:bg-indigo-200 dark:bg-indigo-900/30 dark:text-indigo-300 dark:group-hover:bg-indigo-900/50",
          purple:  "bg-purple-100 text-purple-800 group-hover:bg-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:group-hover:bg-purple-900/50",
          pink:    "bg-pink-100 text-pink-800 group-hover:bg-pink-200 dark:bg-pink-900/30 dark:text-pink-300 dark:group-hover:bg-pink-900/50",
          blue:    "bg-blue-100 text-blue-800 group-hover:bg-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:group-hover:bg-blue-900/50",
          cyan:    "bg-cyan-100 text-cyan-800 group-hover:bg-cyan-200 dark:bg-cyan-900/30 dark:text-cyan-300 dark:group-hover:bg-cyan-900/50",
          dark:    "bg-gray-600 text-gray-100 group-hover:bg-gray-500 dark:bg-gray-800 dark:text-gray-300 dark:group-hover:bg-gray-700",
          light:   "bg-gray-200 text-gray-800 group-hover:bg-gray-300 dark:bg-gray-700/50 dark:text-gray-300 dark:group-hover:bg-gray-700",
          green:   "bg-green-100 text-green-800 group-hover:bg-green-200 dark:bg-green-900/30 dark:text-green-300 dark:group-hover:bg-green-900/50",
          lime:    "bg-lime-100 text-lime-800 group-hover:bg-lime-200 dark:bg-lime-900/30 dark:text-lime-300 dark:group-hover:bg-lime-900/50",
          red:     "bg-red-100 text-red-800 group-hover:bg-red-200 dark:bg-red-900/30 dark:text-red-300 dark:group-hover:bg-red-900/50",
          teal:    "bg-teal-100 text-teal-800 group-hover:bg-teal-200 dark:bg-teal-900/30 dark:text-teal-300 dark:group-hover:bg-teal-900/50",
          yellow:  "bg-yellow-100 text-yellow-800 group-hover:bg-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:group-hover:bg-yellow-900/50",
        }
      }
    },
    dropdown: {
      floating: {
        base: "z-10 w-fit divide-y divide-gray-100 dark:divide-dm-border rounded shadow focus:outline-none",
        content: "py-1 text-sm text-gray-700 dark:text-dm-text",
        divider: "my-1 h-px bg-gray-100 dark:bg-dm-border",
        header: "block px-4 py-2 text-sm text-gray-700 dark:text-dm-text",
        item: {
          container: "",
          base: "flex w-full cursor-pointer items-center justify-start px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none dark:text-dm-text dark:hover:bg-dm-hover dark:hover:text-dm-text dark:focus:bg-dm-hover dark:focus:text-dm-text",
          icon: "mr-2 h-4 w-4"
        },
        style: {
          dark: "bg-gray-900 text-white dark:bg-gray-700",
          light: "border border-gray-200 bg-white text-gray-900",
          auto: "border border-gray-200 bg-white text-gray-900 dark:border-dm-border dark:bg-dm-surface dark:text-dm-text"
        },
      }
    },
    tooltip: {
      "target": "w-fit",
      "animation": "transition-opacity",
      "arrow": {
        "base": "absolute z-10 h-2 w-2 rotate-45",
        "style": {
          "dark": "bg-gray-900 dark:bg-dm-hover",
          "light": "bg-gray-200",
          "auto": "bg-gray-900 dark:bg-dm-hover"
        },
        "placement": "-4px"
      },
      "base": "absolute z-10 inline-block rounded-lg px-3 py-2 text-sm font-medium shadow-sm",
      "hidden": "invisible opacity-0",
      "style": {
        "dark": "bg-gray-900 text-white dark:bg-dm-hover dark:text-dm-text dark:border dark:border-dm-border",
        "light": "border border-gray-200 bg-white text-gray-900",
        "auto": "bg-gray-900 text-white dark:bg-dm-hover dark:text-dm-text dark:border dark:border-dm-border"
      },
      "content": "relative z-20"
    }
};

export default customTheme;